import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ScrollArea, ScrollBar } from './ui/scroll-area';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function CategoryFilter({ activeCategory = null }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  };

  return (
    <div className="mb-8" data-testid="category-filter">
      <ScrollArea className="w-full">
        <div className="flex space-x-3 pb-4">
          <Link
            to="/"
            className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              !activeCategory
                ? 'bg-[#0055FF] text-white'
                : 'bg-white dark:bg-[#121212] text-gray-700 dark:text-gray-300 border border-black/10 dark:border-white/10 hover:border-[#0055FF] dark:hover:border-[#3377FF]'
            }`}
            data-testid="category-all"
          >
            Alle
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                activeCategory === cat.id
                  ? 'bg-[#0055FF] text-white'
                  : 'bg-white dark:bg-[#121212] text-gray-700 dark:text-gray-300 border border-black/10 dark:border-white/10 hover:border-[#0055FF] dark:hover:border-[#3377FF]'
              }`}
              data-testid={`category-${cat.id}`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}

export default CategoryFilter;
